import { memo } from 'react'
import {
    Box,
    Divider,
    Grid,
    IconButton,
    InputAdornment,
    TextField,
    Typography,
} from '@mui/material'
import OrderIcon from '../../assets/icons/Order'
import RefreshIcon from '../../assets/icons/RefreshIcon'
import SearchIcon from '../../assets/icons/SearchIcon'
import ClearIcon from '../../assets/icons/ClearIcon'
import TradingAccountSelector from '../tradingAccountStatus/TradingAccountSelector'
import GenericFilterTabs from '../genericTabs/genericFilterTabs'
import { OrdersNavButtonsDetailed, ordersNavItems } from '../postionsWidget'

export type OrdersPanelHeaderProps = {
    showSync: boolean
    onSync?: () => void
    ordersTableViewType: OrdersNavButtonsDetailed
    onOrdersTableViewTypeChange: (val: OrdersNavButtonsDetailed) => void
    hasOrders: boolean
    showSearch: boolean
    onShowSearch: (show: boolean) => void
    searchText: string
    onSearchTextChange: (text: string) => void
}

const OrdersPanelHeader: React.FC<OrdersPanelHeaderProps> = ({
    showSync,
    onSync,
    ordersTableViewType,
    onOrdersTableViewTypeChange,
    hasOrders,
    showSearch,
    onShowSearch,
    searchText,
    onSearchTextChange,
}) => (
    <Box sx={{ position: 'sticky', top: 0, zIndex: 1 }}>
        <Grid container px={'8px'} py={0} justifyContent={'space-between'} alignItems={'center'}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <OrderIcon sx={{ color: (theme) => theme.palette.text.secondary }} />
                <Typography variant={'body1'}>Orders</Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                {showSync && onSync ? (
                    <IconButton onClick={onSync} sx={{ height: '40px' }}>
                        <RefreshIcon />
                    </IconButton>
                ) : null}
                <TradingAccountSelector compact />
            </Box>
        </Grid>
        <Divider style={{ width: '100%' }} />
        <Grid container justifyContent={'space-between'} style={{ padding: '10px' }}>
            <Grid item>
                {!showSearch && (
                    <GenericFilterTabs<OrdersNavButtonsDetailed>
                        items={ordersNavItems}
                        onChange={(val) => {
                            if (val) onOrdersTableViewTypeChange(val)
                        }}
                        value={ordersTableViewType}
                        tabProps={{ sx: { minWidth: 60 } }}
                        sx={{ height: 28, pr: 1 }}
                    />
                )}
            </Grid>
            {hasOrders &&
                (!showSearch ? (
                    <Grid item>
                        <IconButton onClick={() => onShowSearch(true)} size="small">
                            <SearchIcon />
                        </IconButton>
                    </Grid>
                ) : (
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            autoFocus
                            value={searchText}
                            onChange={(e) => onSearchTextChange(e.target.value)}
                            variant="outlined"
                            size="small"
                            placeholder="Search Symbol"
                            InputProps={{
                                sx: { height: 32, pl: 1 },
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton
                                            size="small"
                                            onClick={() => {
                                                onSearchTextChange('')
                                                onShowSearch(false)
                                            }}
                                        >
                                            <ClearIcon />
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </Grid>
                ))}
        </Grid>
    </Box>
)

export default memo(OrdersPanelHeader)
